import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Image } from '@thd-olt-component-react/image';
import { Button } from '@thd-olt-component-react/button';
import { getCents, getDollars } from '../helpers';

const OrderSampleContent = ({
  link,
  price,
  dimensionText,
  handleClick,
  children,
  multipleSamples
}) => {
  const subTextClasses = classnames('order-sample__sub-text', {
    'order-sample__sub-text--link': link
  });
  return (
    <div className="order-sample">
      <div className="order-sample__details">
        <Image
          className="order-sample__icon"
          alt="more-options-icon"
          src="https://assets.homedepot-static.com/images/v1/more-options.svg"
        />
        <div className="order-sample__info">
          {link ? (
            <Button style={{ width: 'auto' }} link onClick={handleClick}>
              {children}
            </Button>
          ) : (
            children
          )}
          <div className={subTextClasses}>
            Sample a { dimensionText } swatch
            { !!price && (
              <span>&nbsp;for&nbsp;
                <span className="order-sample__sub-text--bold">
                  {price < 1
                    ? <span>{getCents(price)}&cent;</span>
                    : <span>${getDollars(price)}</span>}
                </span>
              </span>
            )}
          </div>
        </div>
      </div>
      {!link && (
        <Button
          className="order-sample__button"
          onClick={handleClick}
          outline
          dark
        >
          {multipleSamples
            ? <span>Choose Sample</span>
            : <span>Add Sample to Cart</span>}
        </Button>
      )}
    </div>
  );
};

OrderSampleContent.propTypes = {
  link: PropTypes.bool,
  price: PropTypes.number,
  handleClick: PropTypes.func.isRequired,
  dimensionText: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  multipleSamples: PropTypes.bool
};

OrderSampleContent.defaultProps = {
  link: false,
  price: NaN,
  multipleSamples: false
};

export default OrderSampleContent;
